/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './app/__root'
import { Route as authLayoutImport } from './app/auth/layout'
import { Route as authenticatedLayoutImport } from './app/_authenticated/layout'
import { Route as registerRouteImport } from './app/register/route'
import { Route as routeImport } from './app/route'
import { Route as authSignupLayoutImport } from './app/auth/signup/layout'
import { Route as authResetTwoFactorLayoutImport } from './app/auth/reset-two-factor/layout'
import { Route as authResetPasswordLayoutImport } from './app/auth/reset-password/layout'
import { Route as authLoginLayoutImport } from './app/auth/login/layout'
import { Route as authenticatedVerificationLayoutImport } from './app/_authenticated/verification/layout'
import { Route as authenticatedTradeLayoutImport } from './app/_authenticated/trade/layout'
import { Route as authenticatedTaxInformationLayoutImport } from './app/_authenticated/tax-information/layout'
import { Route as resetPasswordRouteImport } from './app/reset-password/route'
import { Route as authenticatedRewardsRouteImport } from './app/_authenticated/rewards/route'
import { Route as authenticatedRecurringBuysRouteImport } from './app/_authenticated/recurring-buys/route'
import { Route as authenticatedPortfolioRouteImport } from './app/_authenticated/portfolio/route'
import { Route as authenticatedNotFoundRouteImport } from './app/_authenticated/not-found/route'
import { Route as authenticatedActivityRouteImport } from './app/_authenticated/activity/route'
import { Route as authSignupIndexImport } from './app/auth/signup/index'
import { Route as authenticatedVerificationIndexImport } from './app/_authenticated/verification/index'
import { Route as authSignupAuthenticatedLayoutImport } from './app/auth/signup/_authenticated/layout'
import { Route as authSignupCheckEmailRouteImport } from './app/auth/signup/check-email/route'
import { Route as authResetPasswordSentRouteImport } from './app/auth/reset-password/sent/route'
import { Route as authResetPasswordRequestRouteImport } from './app/auth/reset-password/request/route'
import { Route as authResetPasswordCompletedRouteImport } from './app/auth/reset-password/completed/route'
import { Route as authLogin2faRouteImport } from './app/auth/login/2fa/route'
import { Route as authenticatedVerificationSubmittedRouteImport } from './app/_authenticated/verification/submitted/route'
import { Route as authenticatedVerificationKycRouteImport } from './app/_authenticated/verification/kyc/route'
import { Route as authenticatedVerificationErrorRouteImport } from './app/_authenticated/verification/error/route'
import { Route as authenticatedTradeSellNowRouteImport } from './app/_authenticated/trade/sell-now/route'
import { Route as authenticatedTradeRecurringBuyRouteImport } from './app/_authenticated/trade/recurring-buy/route'
import { Route as authenticatedTradeBuyNowRouteImport } from './app/_authenticated/trade/buy-now/route'
import { Route as authenticatedTaxInformationReviewTaxInformationRouteImport } from './app/_authenticated/tax-information/review-tax-information/route'
import { Route as authenticatedTaxInformationEditTaxInformationRouteImport } from './app/_authenticated/tax-information/edit-tax-information/route'
import { Route as authenticatedTaxInformationAddTaxIdentificationNumberRouteImport } from './app/_authenticated/tax-information/add-tax-identification-number/route'
import { Route as authenticatedTaxInformationAddHomeAddressRouteImport } from './app/_authenticated/tax-information/add-home-address/route'
import { Route as authenticatedTaxInformationAddCountryOfTaxResidenceRouteImport } from './app/_authenticated/tax-information/add-country-of-tax-residence/route'
import { Route as authenticatedSettingsUpdatePasswordRouteImport } from './app/_authenticated/settings/update-password/route'
import { Route as authenticatedSettingsTwoFactorRouteImport } from './app/_authenticated/settings/two-factor/route'
import { Route as authenticatedSettingsLoginMethodRouteImport } from './app/_authenticated/settings/login-method/route'
import { Route as authenticatedProductsDetailsRouteImport } from './app/_authenticated/products/details/route'
import { Route as authResetTwoFactorRouteImport } from './app/auth/reset-two-factor/route'
import { Route as authResetPasswordRouteImport } from './app/auth/reset-password/route'
import { Route as authLoginRouteImport } from './app/auth/login/route'
import { Route as authenticatedTaxInformationAddCountryOfResidenceRouteImport } from './app/_authenticated/tax-information/add-country-of-residence/route'
import { Route as authenticatedSettingsRouteImport } from './app/_authenticated/settings/route'
import { Route as authenticatedProductsExploreRouteImport } from './app/_authenticated/products/explore/route'
import { Route as authenticatedAiInsightsRouteImport } from './app/_authenticated/ai-insights/route'
import { Route as authSignupAuthenticatedWelcomeRouteImport } from './app/auth/signup/_authenticated/welcome/route'
import { Route as authSignupAuthenticatedVerifyEmailRouteImport } from './app/auth/signup/_authenticated/verify-email/route'
import { Route as authSignupAuthenticatedTosRouteImport } from './app/auth/signup/_authenticated/tos/route'
import { Route as authSignupAuthenticatedAccountDetailsRouteImport } from './app/auth/signup/_authenticated/account-details/route'
import { Route as authResetTwoFactorSubmittedRouteImport } from './app/auth/reset-two-factor/submitted/route'
import { Route as authenticatedSettingsOtpEnableRouteImport } from './app/_authenticated/settings/otp/enable/route'
import { Route as authenticatedFundsWithdrawRouteImport } from './app/_authenticated/funds/withdraw/route'
import { Route as authenticatedFundsDepositRouteImport } from './app/_authenticated/funds/deposit/route'
import { Route as authenticatedFundsDepositFiatRouteImport } from './app/_authenticated/funds/deposit/fiat/route'
import { Route as authenticatedFundsDepositCryptoRouteImport } from './app/_authenticated/funds/deposit/crypto/route'
import { Route as authenticatedFundsWithdrawFiatProductCodeOtpRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/otp/route'
import { Route as authenticatedFundsWithdrawFiatProductCodeCompleteRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/complete/route'
import { Route as authenticatedFundsWithdrawFiatProductCode2faRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/2fa/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeOtpRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/otp/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeCompleteRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/complete/route'
import { Route as authenticatedFundsWithdrawCryptoProductCode2faRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/2fa/route'
import { Route as authenticatedFundsDepositFiatBankPopRouteImport } from './app/_authenticated/funds/deposit/fiat/bank/pop/route'
import { Route as authenticatedFundsDepositCryptoProductCodeCompleteRouteImport } from './app/_authenticated/funds/deposit/crypto/$productCode/complete/route'
import { Route as authenticatedFundsDepositCryptoProductCodeAddressRouteImport } from './app/_authenticated/funds/deposit/crypto/$productCode/address/route'
import { Route as authenticatedFundsWithdrawFiatProductCodeRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/route'
import { Route as authenticatedFundsDepositFiatBankRouteImport } from './app/_authenticated/funds/deposit/fiat/bank/route'
import { Route as authenticatedFundsDepositCryptoProductCodeRouteImport } from './app/_authenticated/funds/deposit/crypto/$productCode/route'
import { Route as authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review/route'
import { Route as authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteImport } from './app/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details/route'
import { Route as authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteImport } from './app/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm/route'

// Create Virtual Routes

const AuthResetTwoFactorImport = createFileRoute('/auth/reset-two-factor/_')()

// Create/Update Routes

const authLayoutRoute = authLayoutImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedLayoutRoute = authenticatedLayoutImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const registerRouteRoute = registerRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const routeRoute = routeImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const authSignupLayoutRoute = authSignupLayoutImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => authLayoutRoute,
} as any)

const authResetTwoFactorLayoutRoute = authResetTwoFactorLayoutImport.update({
  id: '/reset-two-factor',
  path: '/reset-two-factor',
  getParentRoute: () => authLayoutRoute,
} as any)

const authResetPasswordLayoutRoute = authResetPasswordLayoutImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLoginLayoutRoute = authLoginLayoutImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authLayoutRoute,
} as any)

const authenticatedVerificationLayoutRoute =
  authenticatedVerificationLayoutImport.update({
    id: '/verification',
    path: '/verification',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedTradeLayoutRoute = authenticatedTradeLayoutImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => authenticatedLayoutRoute,
} as any)

const authenticatedTaxInformationLayoutRoute =
  authenticatedTaxInformationLayoutImport.update({
    id: '/tax-information',
    path: '/tax-information',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const resetPasswordRouteRoute = resetPasswordRouteImport.update({
  id: '/reset-password/resetPassword',
  path: '/reset-password/resetPassword',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedRewardsRouteRoute = authenticatedRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => authenticatedLayoutRoute,
} as any)

const authenticatedRecurringBuysRouteRoute =
  authenticatedRecurringBuysRouteImport.update({
    id: '/recurring-buys',
    path: '/recurring-buys',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedPortfolioRouteRoute =
  authenticatedPortfolioRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedNotFoundRouteRoute = authenticatedNotFoundRouteImport.update(
  {
    id: '/not-found',
    path: '/not-found',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any,
)

const authenticatedActivityRouteRoute = authenticatedActivityRouteImport.update(
  {
    id: '/activity',
    path: '/activity',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any,
)

const AuthResetTwoFactorRoute = AuthResetTwoFactorImport.update({
  id: '/_',
  getParentRoute: () => authResetTwoFactorLayoutRoute,
} as any)

const authSignupIndexRoute = authSignupIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authSignupLayoutRoute,
} as any)

const authenticatedVerificationIndexRoute =
  authenticatedVerificationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedVerificationLayoutRoute,
  } as any)

const authSignupAuthenticatedLayoutRoute =
  authSignupAuthenticatedLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => authSignupLayoutRoute,
  } as any)

const authSignupCheckEmailRouteRoute = authSignupCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => authSignupLayoutRoute,
} as any)

const authResetPasswordSentRouteRoute = authResetPasswordSentRouteImport.update(
  {
    id: '/sent',
    path: '/sent',
    getParentRoute: () => authResetPasswordLayoutRoute,
  } as any,
)

const authResetPasswordRequestRouteRoute =
  authResetPasswordRequestRouteImport.update({
    id: '/request',
    path: '/request',
    getParentRoute: () => authResetPasswordLayoutRoute,
  } as any)

const authResetPasswordCompletedRouteRoute =
  authResetPasswordCompletedRouteImport.update({
    id: '/completed',
    path: '/completed',
    getParentRoute: () => authResetPasswordLayoutRoute,
  } as any)

const authLogin2faRouteRoute = authLogin2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => authLoginLayoutRoute,
} as any)

const authenticatedVerificationSubmittedRouteRoute =
  authenticatedVerificationSubmittedRouteImport.update({
    id: '/submitted',
    path: '/submitted',
    getParentRoute: () => authenticatedVerificationLayoutRoute,
  } as any)

const authenticatedVerificationKycRouteRoute =
  authenticatedVerificationKycRouteImport.update({
    id: '/kyc',
    path: '/kyc',
    getParentRoute: () => authenticatedVerificationLayoutRoute,
  } as any)

const authenticatedVerificationErrorRouteRoute =
  authenticatedVerificationErrorRouteImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => authenticatedVerificationLayoutRoute,
  } as any)

const authenticatedTradeSellNowRouteRoute =
  authenticatedTradeSellNowRouteImport.update({
    id: '/sell-now',
    path: '/sell-now',
    getParentRoute: () => authenticatedTradeLayoutRoute,
  } as any)

const authenticatedTradeRecurringBuyRouteRoute =
  authenticatedTradeRecurringBuyRouteImport.update({
    id: '/recurring-buy',
    path: '/recurring-buy',
    getParentRoute: () => authenticatedTradeLayoutRoute,
  } as any)

const authenticatedTradeBuyNowRouteRoute =
  authenticatedTradeBuyNowRouteImport.update({
    id: '/buy-now',
    path: '/buy-now',
    getParentRoute: () => authenticatedTradeLayoutRoute,
  } as any)

const authenticatedTaxInformationReviewTaxInformationRouteRoute =
  authenticatedTaxInformationReviewTaxInformationRouteImport.update({
    id: '/review-tax-information',
    path: '/review-tax-information',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedTaxInformationEditTaxInformationRouteRoute =
  authenticatedTaxInformationEditTaxInformationRouteImport.update({
    id: '/edit-tax-information',
    path: '/edit-tax-information',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute =
  authenticatedTaxInformationAddTaxIdentificationNumberRouteImport.update({
    id: '/add-tax-identification-number',
    path: '/add-tax-identification-number',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedTaxInformationAddHomeAddressRouteRoute =
  authenticatedTaxInformationAddHomeAddressRouteImport.update({
    id: '/add-home-address',
    path: '/add-home-address',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute =
  authenticatedTaxInformationAddCountryOfTaxResidenceRouteImport.update({
    id: '/add-country-of-tax-residence',
    path: '/add-country-of-tax-residence',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedSettingsUpdatePasswordRouteRoute =
  authenticatedSettingsUpdatePasswordRouteImport.update({
    id: '/settings/update-password',
    path: '/settings/update-password',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedSettingsTwoFactorRouteRoute =
  authenticatedSettingsTwoFactorRouteImport.update({
    id: '/settings/two-factor',
    path: '/settings/two-factor',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedSettingsLoginMethodRouteRoute =
  authenticatedSettingsLoginMethodRouteImport.update({
    id: '/settings/login-method',
    path: '/settings/login-method',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedProductsDetailsRouteRoute =
  authenticatedProductsDetailsRouteImport.update({
    id: '/products/$productCode',
    path: '/products/$productCode',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authResetTwoFactorRouteRoute = authResetTwoFactorRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authResetTwoFactorLayoutRoute,
} as any)

const authResetPasswordRouteRoute = authResetPasswordRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authResetPasswordLayoutRoute,
} as any)

const authLoginRouteRoute = authLoginRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authLoginLayoutRoute,
} as any)

const authenticatedTaxInformationAddCountryOfResidenceRouteRoute =
  authenticatedTaxInformationAddCountryOfResidenceRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedTaxInformationLayoutRoute,
  } as any)

const authenticatedSettingsRouteRoute = authenticatedSettingsRouteImport.update(
  {
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any,
)

const authenticatedProductsExploreRouteRoute =
  authenticatedProductsExploreRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedAiInsightsRouteRoute =
  authenticatedAiInsightsRouteImport.update({
    id: '/ai-insights/',
    path: '/ai-insights/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authSignupAuthenticatedWelcomeRouteRoute =
  authSignupAuthenticatedWelcomeRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => authSignupAuthenticatedLayoutRoute,
  } as any)

const authSignupAuthenticatedVerifyEmailRouteRoute =
  authSignupAuthenticatedVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => authSignupAuthenticatedLayoutRoute,
  } as any)

const authSignupAuthenticatedTosRouteRoute =
  authSignupAuthenticatedTosRouteImport.update({
    id: '/tos',
    path: '/tos',
    getParentRoute: () => authSignupAuthenticatedLayoutRoute,
  } as any)

const authSignupAuthenticatedAccountDetailsRouteRoute =
  authSignupAuthenticatedAccountDetailsRouteImport.update({
    id: '/account-details',
    path: '/account-details',
    getParentRoute: () => authSignupAuthenticatedLayoutRoute,
  } as any)

const authResetTwoFactorSubmittedRouteRoute =
  authResetTwoFactorSubmittedRouteImport.update({
    id: '/submitted',
    path: '/submitted',
    getParentRoute: () => AuthResetTwoFactorRoute,
  } as any)

const authenticatedSettingsOtpEnableRouteRoute =
  authenticatedSettingsOtpEnableRouteImport.update({
    id: '/settings/otp/enable',
    path: '/settings/otp/enable',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawRouteRoute =
  authenticatedFundsWithdrawRouteImport.update({
    id: '/funds/withdraw/',
    path: '/funds/withdraw/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositRouteRoute =
  authenticatedFundsDepositRouteImport.update({
    id: '/funds/deposit/',
    path: '/funds/deposit/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositFiatRouteRoute =
  authenticatedFundsDepositFiatRouteImport.update({
    id: '/funds/deposit/fiat/',
    path: '/funds/deposit/fiat/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositCryptoRouteRoute =
  authenticatedFundsDepositCryptoRouteImport.update({
    id: '/funds/deposit/crypto/',
    path: '/funds/deposit/crypto/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute =
  authenticatedFundsWithdrawFiatProductCodeOtpRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/otp',
    path: '/funds/withdraw/fiat/$productCode/otp',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute =
  authenticatedFundsWithdrawFiatProductCodeCompleteRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/complete',
    path: '/funds/withdraw/fiat/$productCode/complete',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCode2faRouteRoute =
  authenticatedFundsWithdrawFiatProductCode2faRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/2fa',
    path: '/funds/withdraw/fiat/$productCode/2fa',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeOtpRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/otp',
    path: '/funds/withdraw/crypto/$productCode/otp',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeCompleteRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/complete',
    path: '/funds/withdraw/crypto/$productCode/complete',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCode2faRouteRoute =
  authenticatedFundsWithdrawCryptoProductCode2faRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/2fa',
    path: '/funds/withdraw/crypto/$productCode/2fa',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositFiatBankPopRouteRoute =
  authenticatedFundsDepositFiatBankPopRouteImport.update({
    id: '/funds/deposit/fiat/bank/pop',
    path: '/funds/deposit/fiat/bank/pop',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute =
  authenticatedFundsDepositCryptoProductCodeCompleteRouteImport.update({
    id: '/funds/deposit/crypto/$productCode/complete',
    path: '/funds/deposit/crypto/$productCode/complete',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositCryptoProductCodeAddressRouteRoute =
  authenticatedFundsDepositCryptoProductCodeAddressRouteImport.update({
    id: '/funds/deposit/crypto/$productCode/address',
    path: '/funds/deposit/crypto/$productCode/address',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCodeRouteRoute =
  authenticatedFundsWithdrawFiatProductCodeRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/',
    path: '/funds/withdraw/fiat/$productCode/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/',
    path: '/funds/withdraw/crypto/$productCode/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositFiatBankRouteRoute =
  authenticatedFundsDepositFiatBankRouteImport.update({
    id: '/funds/deposit/fiat/bank/',
    path: '/funds/deposit/fiat/bank/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsDepositCryptoProductCodeRouteRoute =
  authenticatedFundsDepositCryptoProductCodeRouteImport.update({
    id: '/funds/deposit/crypto/$productCode/',
    path: '/funds/deposit/crypto/$productCode/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute =
  authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/bank-details/review',
    path: '/funds/withdraw/fiat/$productCode/bank-details/review',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute =
  authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteImport.update({
    id: '/funds/withdraw/fiat/$productCode/bank-details/edit',
    path: '/funds/withdraw/fiat/$productCode/bank-details/edit',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/wallet/verify',
    path: '/funds/withdraw/crypto/$productCode/wallet/verify',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteImport.update(
    {
      id: '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge',
      path: '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge',
      getParentRoute: () => authenticatedLayoutRoute,
    } as any,
  )

const authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteImport.update(
    {
      id: '/funds/withdraw/crypto/$productCode/disclaimer/accept',
      path: '/funds/withdraw/crypto/$productCode/disclaimer/accept',
      getParentRoute: () => authenticatedLayoutRoute,
    } as any,
  )

const authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteImport.update(
    {
      id: '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule',
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule',
      getParentRoute: () => authenticatedLayoutRoute,
    } as any,
  )

const authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteImport.update({
    id: '/funds/withdraw/crypto/$productCode/wallet/edit/otp',
    path: '/funds/withdraw/crypto/$productCode/wallet/edit/otp',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteImport.update(
    {
      id: '/funds/withdraw/crypto/$productCode/wallet/edit/details',
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/details',
      getParentRoute: () => authenticatedLayoutRoute,
    } as any,
  )

const authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute =
  authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteImport.update(
    {
      id: '/funds/withdraw/crypto/$productCode/wallet/edit/confirm',
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/confirm',
      getParentRoute: () => authenticatedLayoutRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof routeImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof registerRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authenticatedLayoutImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof authenticatedActivityRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/not-found': {
      id: '/_authenticated/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof authenticatedNotFoundRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/portfolio': {
      id: '/_authenticated/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof authenticatedPortfolioRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/recurring-buys': {
      id: '/_authenticated/recurring-buys'
      path: '/recurring-buys'
      fullPath: '/recurring-buys'
      preLoaderRoute: typeof authenticatedRecurringBuysRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/rewards': {
      id: '/_authenticated/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof authenticatedRewardsRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/reset-password/resetPassword': {
      id: '/reset-password/resetPassword'
      path: '/reset-password/resetPassword'
      fullPath: '/reset-password/resetPassword'
      preLoaderRoute: typeof resetPasswordRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/tax-information': {
      id: '/_authenticated/tax-information'
      path: '/tax-information'
      fullPath: '/tax-information'
      preLoaderRoute: typeof authenticatedTaxInformationLayoutImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/trade': {
      id: '/_authenticated/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof authenticatedTradeLayoutImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/verification': {
      id: '/_authenticated/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof authenticatedVerificationLayoutImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof authLoginLayoutImport
      parentRoute: typeof authLayoutImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof authResetPasswordLayoutImport
      parentRoute: typeof authLayoutImport
    }
    '/auth/reset-two-factor': {
      id: '/auth/reset-two-factor'
      path: '/reset-two-factor'
      fullPath: '/auth/reset-two-factor'
      preLoaderRoute: typeof authResetTwoFactorLayoutImport
      parentRoute: typeof authLayoutImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof authSignupLayoutImport
      parentRoute: typeof authLayoutImport
    }
    '/_authenticated/ai-insights/': {
      id: '/_authenticated/ai-insights/'
      path: '/ai-insights'
      fullPath: '/ai-insights'
      preLoaderRoute: typeof authenticatedAiInsightsRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof authenticatedProductsExploreRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof authenticatedSettingsRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/tax-information/': {
      id: '/_authenticated/tax-information/'
      path: '/'
      fullPath: '/tax-information/'
      preLoaderRoute: typeof authenticatedTaxInformationAddCountryOfResidenceRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/auth/login/': {
      id: '/auth/login/'
      path: '/'
      fullPath: '/auth/login/'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authLoginLayoutImport
    }
    '/auth/reset-password/': {
      id: '/auth/reset-password/'
      path: '/'
      fullPath: '/auth/reset-password/'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authResetPasswordLayoutImport
    }
    '/auth/reset-two-factor/': {
      id: '/auth/reset-two-factor/'
      path: '/'
      fullPath: '/auth/reset-two-factor/'
      preLoaderRoute: typeof authResetTwoFactorRouteImport
      parentRoute: typeof authResetTwoFactorLayoutImport
    }
    '/_authenticated/products/$productCode': {
      id: '/_authenticated/products/$productCode'
      path: '/products/$productCode'
      fullPath: '/products/$productCode'
      preLoaderRoute: typeof authenticatedProductsDetailsRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/settings/login-method': {
      id: '/_authenticated/settings/login-method'
      path: '/settings/login-method'
      fullPath: '/settings/login-method'
      preLoaderRoute: typeof authenticatedSettingsLoginMethodRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/settings/two-factor': {
      id: '/_authenticated/settings/two-factor'
      path: '/settings/two-factor'
      fullPath: '/settings/two-factor'
      preLoaderRoute: typeof authenticatedSettingsTwoFactorRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/settings/update-password': {
      id: '/_authenticated/settings/update-password'
      path: '/settings/update-password'
      fullPath: '/settings/update-password'
      preLoaderRoute: typeof authenticatedSettingsUpdatePasswordRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/tax-information/add-country-of-tax-residence': {
      id: '/_authenticated/tax-information/add-country-of-tax-residence'
      path: '/add-country-of-tax-residence'
      fullPath: '/tax-information/add-country-of-tax-residence'
      preLoaderRoute: typeof authenticatedTaxInformationAddCountryOfTaxResidenceRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/_authenticated/tax-information/add-home-address': {
      id: '/_authenticated/tax-information/add-home-address'
      path: '/add-home-address'
      fullPath: '/tax-information/add-home-address'
      preLoaderRoute: typeof authenticatedTaxInformationAddHomeAddressRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/_authenticated/tax-information/add-tax-identification-number': {
      id: '/_authenticated/tax-information/add-tax-identification-number'
      path: '/add-tax-identification-number'
      fullPath: '/tax-information/add-tax-identification-number'
      preLoaderRoute: typeof authenticatedTaxInformationAddTaxIdentificationNumberRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/_authenticated/tax-information/edit-tax-information': {
      id: '/_authenticated/tax-information/edit-tax-information'
      path: '/edit-tax-information'
      fullPath: '/tax-information/edit-tax-information'
      preLoaderRoute: typeof authenticatedTaxInformationEditTaxInformationRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/_authenticated/tax-information/review-tax-information': {
      id: '/_authenticated/tax-information/review-tax-information'
      path: '/review-tax-information'
      fullPath: '/tax-information/review-tax-information'
      preLoaderRoute: typeof authenticatedTaxInformationReviewTaxInformationRouteImport
      parentRoute: typeof authenticatedTaxInformationLayoutImport
    }
    '/_authenticated/trade/buy-now': {
      id: '/_authenticated/trade/buy-now'
      path: '/buy-now'
      fullPath: '/trade/buy-now'
      preLoaderRoute: typeof authenticatedTradeBuyNowRouteImport
      parentRoute: typeof authenticatedTradeLayoutImport
    }
    '/_authenticated/trade/recurring-buy': {
      id: '/_authenticated/trade/recurring-buy'
      path: '/recurring-buy'
      fullPath: '/trade/recurring-buy'
      preLoaderRoute: typeof authenticatedTradeRecurringBuyRouteImport
      parentRoute: typeof authenticatedTradeLayoutImport
    }
    '/_authenticated/trade/sell-now': {
      id: '/_authenticated/trade/sell-now'
      path: '/sell-now'
      fullPath: '/trade/sell-now'
      preLoaderRoute: typeof authenticatedTradeSellNowRouteImport
      parentRoute: typeof authenticatedTradeLayoutImport
    }
    '/_authenticated/verification/error': {
      id: '/_authenticated/verification/error'
      path: '/error'
      fullPath: '/verification/error'
      preLoaderRoute: typeof authenticatedVerificationErrorRouteImport
      parentRoute: typeof authenticatedVerificationLayoutImport
    }
    '/_authenticated/verification/kyc': {
      id: '/_authenticated/verification/kyc'
      path: '/kyc'
      fullPath: '/verification/kyc'
      preLoaderRoute: typeof authenticatedVerificationKycRouteImport
      parentRoute: typeof authenticatedVerificationLayoutImport
    }
    '/_authenticated/verification/submitted': {
      id: '/_authenticated/verification/submitted'
      path: '/submitted'
      fullPath: '/verification/submitted'
      preLoaderRoute: typeof authenticatedVerificationSubmittedRouteImport
      parentRoute: typeof authenticatedVerificationLayoutImport
    }
    '/auth/login/2fa': {
      id: '/auth/login/2fa'
      path: '/2fa'
      fullPath: '/auth/login/2fa'
      preLoaderRoute: typeof authLogin2faRouteImport
      parentRoute: typeof authLoginLayoutImport
    }
    '/auth/reset-password/completed': {
      id: '/auth/reset-password/completed'
      path: '/completed'
      fullPath: '/auth/reset-password/completed'
      preLoaderRoute: typeof authResetPasswordCompletedRouteImport
      parentRoute: typeof authResetPasswordLayoutImport
    }
    '/auth/reset-password/request': {
      id: '/auth/reset-password/request'
      path: '/request'
      fullPath: '/auth/reset-password/request'
      preLoaderRoute: typeof authResetPasswordRequestRouteImport
      parentRoute: typeof authResetPasswordLayoutImport
    }
    '/auth/reset-password/sent': {
      id: '/auth/reset-password/sent'
      path: '/sent'
      fullPath: '/auth/reset-password/sent'
      preLoaderRoute: typeof authResetPasswordSentRouteImport
      parentRoute: typeof authResetPasswordLayoutImport
    }
    '/auth/signup/check-email': {
      id: '/auth/signup/check-email'
      path: '/check-email'
      fullPath: '/auth/signup/check-email'
      preLoaderRoute: typeof authSignupCheckEmailRouteImport
      parentRoute: typeof authSignupLayoutImport
    }
    '/auth/signup/_layout': {
      id: '/auth/signup/_layout'
      path: ''
      fullPath: '/auth/signup'
      preLoaderRoute: typeof authSignupAuthenticatedLayoutImport
      parentRoute: typeof authSignupLayoutImport
    }
    '/_authenticated/verification/': {
      id: '/_authenticated/verification/'
      path: '/'
      fullPath: '/verification/'
      preLoaderRoute: typeof authenticatedVerificationIndexImport
      parentRoute: typeof authenticatedVerificationLayoutImport
    }
    '/auth/signup/': {
      id: '/auth/signup/'
      path: '/'
      fullPath: '/auth/signup/'
      preLoaderRoute: typeof authSignupIndexImport
      parentRoute: typeof authSignupLayoutImport
    }
    '/_authenticated/funds/deposit/': {
      id: '/_authenticated/funds/deposit/'
      path: '/funds/deposit'
      fullPath: '/funds/deposit'
      preLoaderRoute: typeof authenticatedFundsDepositRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/': {
      id: '/_authenticated/funds/withdraw/'
      path: '/funds/withdraw'
      fullPath: '/funds/withdraw'
      preLoaderRoute: typeof authenticatedFundsWithdrawRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/settings/otp/enable': {
      id: '/_authenticated/settings/otp/enable'
      path: '/settings/otp/enable'
      fullPath: '/settings/otp/enable'
      preLoaderRoute: typeof authenticatedSettingsOtpEnableRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/auth/reset-two-factor/_': {
      id: '/auth/reset-two-factor/_'
      path: ''
      fullPath: '/auth/reset-two-factor'
      preLoaderRoute: typeof AuthResetTwoFactorImport
      parentRoute: typeof authResetTwoFactorLayoutImport
    }
    '/auth/reset-two-factor/_/submitted': {
      id: '/auth/reset-two-factor/_/submitted'
      path: '/submitted'
      fullPath: '/auth/reset-two-factor/submitted'
      preLoaderRoute: typeof authResetTwoFactorSubmittedRouteImport
      parentRoute: typeof AuthResetTwoFactorRoute
    }
    '/auth/signup/_layout/account-details': {
      id: '/auth/signup/_layout/account-details'
      path: '/account-details'
      fullPath: '/auth/signup/account-details'
      preLoaderRoute: typeof authSignupAuthenticatedAccountDetailsRouteImport
      parentRoute: typeof authSignupAuthenticatedLayoutImport
    }
    '/auth/signup/_layout/tos': {
      id: '/auth/signup/_layout/tos'
      path: '/tos'
      fullPath: '/auth/signup/tos'
      preLoaderRoute: typeof authSignupAuthenticatedTosRouteImport
      parentRoute: typeof authSignupAuthenticatedLayoutImport
    }
    '/auth/signup/_layout/verify-email': {
      id: '/auth/signup/_layout/verify-email'
      path: '/verify-email'
      fullPath: '/auth/signup/verify-email'
      preLoaderRoute: typeof authSignupAuthenticatedVerifyEmailRouteImport
      parentRoute: typeof authSignupAuthenticatedLayoutImport
    }
    '/auth/signup/_layout/welcome': {
      id: '/auth/signup/_layout/welcome'
      path: '/welcome'
      fullPath: '/auth/signup/welcome'
      preLoaderRoute: typeof authSignupAuthenticatedWelcomeRouteImport
      parentRoute: typeof authSignupAuthenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/crypto/': {
      id: '/_authenticated/funds/deposit/crypto/'
      path: '/funds/deposit/crypto'
      fullPath: '/funds/deposit/crypto'
      preLoaderRoute: typeof authenticatedFundsDepositCryptoRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/fiat/': {
      id: '/_authenticated/funds/deposit/fiat/'
      path: '/funds/deposit/fiat'
      fullPath: '/funds/deposit/fiat'
      preLoaderRoute: typeof authenticatedFundsDepositFiatRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/crypto/$productCode/': {
      id: '/_authenticated/funds/deposit/crypto/$productCode/'
      path: '/funds/deposit/crypto/$productCode'
      fullPath: '/funds/deposit/crypto/$productCode'
      preLoaderRoute: typeof authenticatedFundsDepositCryptoProductCodeRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/fiat/bank/': {
      id: '/_authenticated/funds/deposit/fiat/bank/'
      path: '/funds/deposit/fiat/bank'
      fullPath: '/funds/deposit/fiat/bank'
      preLoaderRoute: typeof authenticatedFundsDepositFiatBankRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/'
      path: '/funds/withdraw/crypto/$productCode'
      fullPath: '/funds/withdraw/crypto/$productCode'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/'
      path: '/funds/withdraw/fiat/$productCode'
      fullPath: '/funds/withdraw/fiat/$productCode'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCodeRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/crypto/$productCode/address': {
      id: '/_authenticated/funds/deposit/crypto/$productCode/address'
      path: '/funds/deposit/crypto/$productCode/address'
      fullPath: '/funds/deposit/crypto/$productCode/address'
      preLoaderRoute: typeof authenticatedFundsDepositCryptoProductCodeAddressRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/crypto/$productCode/complete': {
      id: '/_authenticated/funds/deposit/crypto/$productCode/complete'
      path: '/funds/deposit/crypto/$productCode/complete'
      fullPath: '/funds/deposit/crypto/$productCode/complete'
      preLoaderRoute: typeof authenticatedFundsDepositCryptoProductCodeCompleteRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/deposit/fiat/bank/pop': {
      id: '/_authenticated/funds/deposit/fiat/bank/pop'
      path: '/funds/deposit/fiat/bank/pop'
      fullPath: '/funds/deposit/fiat/bank/pop'
      preLoaderRoute: typeof authenticatedFundsDepositFiatBankPopRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/2fa': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/2fa'
      path: '/funds/withdraw/crypto/$productCode/2fa'
      fullPath: '/funds/withdraw/crypto/$productCode/2fa'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCode2faRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/complete': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/complete'
      path: '/funds/withdraw/crypto/$productCode/complete'
      fullPath: '/funds/withdraw/crypto/$productCode/complete'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeCompleteRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/otp': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/otp'
      path: '/funds/withdraw/crypto/$productCode/otp'
      fullPath: '/funds/withdraw/crypto/$productCode/otp'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeOtpRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/2fa': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/2fa'
      path: '/funds/withdraw/fiat/$productCode/2fa'
      fullPath: '/funds/withdraw/fiat/$productCode/2fa'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCode2faRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/complete': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/complete'
      path: '/funds/withdraw/fiat/$productCode/complete'
      fullPath: '/funds/withdraw/fiat/$productCode/complete'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCodeCompleteRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/otp': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/otp'
      path: '/funds/withdraw/fiat/$productCode/otp'
      fullPath: '/funds/withdraw/fiat/$productCode/otp'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCodeOtpRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept'
      path: '/funds/withdraw/crypto/$productCode/disclaimer/accept'
      fullPath: '/funds/withdraw/crypto/$productCode/disclaimer/accept'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
      path: '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
      fullPath: '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify'
      path: '/funds/withdraw/crypto/$productCode/wallet/verify'
      fullPath: '/funds/withdraw/crypto/$productCode/wallet/verify'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit'
      path: '/funds/withdraw/fiat/$productCode/bank-details/edit'
      fullPath: '/funds/withdraw/fiat/$productCode/bank-details/edit'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review': {
      id: '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review'
      path: '/funds/withdraw/fiat/$productCode/bank-details/review'
      fullPath: '/funds/withdraw/fiat/$productCode/bank-details/review'
      preLoaderRoute: typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
      fullPath: '/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details'
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/details'
      fullPath: '/funds/withdraw/crypto/$productCode/wallet/edit/details'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp'
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/otp'
      fullPath: '/funds/withdraw/crypto/$productCode/wallet/edit/otp'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule': {
      id: '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
      path: '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
      fullPath: '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
      preLoaderRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteImport
      parentRoute: typeof authenticatedLayoutImport
    }
  }
}

// Create and export the route tree

interface authenticatedTaxInformationLayoutRouteChildren {
  authenticatedTaxInformationAddCountryOfResidenceRouteRoute: typeof authenticatedTaxInformationAddCountryOfResidenceRouteRoute
  authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute: typeof authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute
  authenticatedTaxInformationAddHomeAddressRouteRoute: typeof authenticatedTaxInformationAddHomeAddressRouteRoute
  authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute: typeof authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute
  authenticatedTaxInformationEditTaxInformationRouteRoute: typeof authenticatedTaxInformationEditTaxInformationRouteRoute
  authenticatedTaxInformationReviewTaxInformationRouteRoute: typeof authenticatedTaxInformationReviewTaxInformationRouteRoute
}

const authenticatedTaxInformationLayoutRouteChildren: authenticatedTaxInformationLayoutRouteChildren =
  {
    authenticatedTaxInformationAddCountryOfResidenceRouteRoute:
      authenticatedTaxInformationAddCountryOfResidenceRouteRoute,
    authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute:
      authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute,
    authenticatedTaxInformationAddHomeAddressRouteRoute:
      authenticatedTaxInformationAddHomeAddressRouteRoute,
    authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute:
      authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute,
    authenticatedTaxInformationEditTaxInformationRouteRoute:
      authenticatedTaxInformationEditTaxInformationRouteRoute,
    authenticatedTaxInformationReviewTaxInformationRouteRoute:
      authenticatedTaxInformationReviewTaxInformationRouteRoute,
  }

const authenticatedTaxInformationLayoutRouteWithChildren =
  authenticatedTaxInformationLayoutRoute._addFileChildren(
    authenticatedTaxInformationLayoutRouteChildren,
  )

interface authenticatedTradeLayoutRouteChildren {
  authenticatedTradeBuyNowRouteRoute: typeof authenticatedTradeBuyNowRouteRoute
  authenticatedTradeRecurringBuyRouteRoute: typeof authenticatedTradeRecurringBuyRouteRoute
  authenticatedTradeSellNowRouteRoute: typeof authenticatedTradeSellNowRouteRoute
}

const authenticatedTradeLayoutRouteChildren: authenticatedTradeLayoutRouteChildren =
  {
    authenticatedTradeBuyNowRouteRoute: authenticatedTradeBuyNowRouteRoute,
    authenticatedTradeRecurringBuyRouteRoute:
      authenticatedTradeRecurringBuyRouteRoute,
    authenticatedTradeSellNowRouteRoute: authenticatedTradeSellNowRouteRoute,
  }

const authenticatedTradeLayoutRouteWithChildren =
  authenticatedTradeLayoutRoute._addFileChildren(
    authenticatedTradeLayoutRouteChildren,
  )

interface authenticatedVerificationLayoutRouteChildren {
  authenticatedVerificationErrorRouteRoute: typeof authenticatedVerificationErrorRouteRoute
  authenticatedVerificationKycRouteRoute: typeof authenticatedVerificationKycRouteRoute
  authenticatedVerificationSubmittedRouteRoute: typeof authenticatedVerificationSubmittedRouteRoute
  authenticatedVerificationIndexRoute: typeof authenticatedVerificationIndexRoute
}

const authenticatedVerificationLayoutRouteChildren: authenticatedVerificationLayoutRouteChildren =
  {
    authenticatedVerificationErrorRouteRoute:
      authenticatedVerificationErrorRouteRoute,
    authenticatedVerificationKycRouteRoute:
      authenticatedVerificationKycRouteRoute,
    authenticatedVerificationSubmittedRouteRoute:
      authenticatedVerificationSubmittedRouteRoute,
    authenticatedVerificationIndexRoute: authenticatedVerificationIndexRoute,
  }

const authenticatedVerificationLayoutRouteWithChildren =
  authenticatedVerificationLayoutRoute._addFileChildren(
    authenticatedVerificationLayoutRouteChildren,
  )

interface authenticatedLayoutRouteChildren {
  authenticatedActivityRouteRoute: typeof authenticatedActivityRouteRoute
  authenticatedNotFoundRouteRoute: typeof authenticatedNotFoundRouteRoute
  authenticatedPortfolioRouteRoute: typeof authenticatedPortfolioRouteRoute
  authenticatedRecurringBuysRouteRoute: typeof authenticatedRecurringBuysRouteRoute
  authenticatedRewardsRouteRoute: typeof authenticatedRewardsRouteRoute
  authenticatedTaxInformationLayoutRoute: typeof authenticatedTaxInformationLayoutRouteWithChildren
  authenticatedTradeLayoutRoute: typeof authenticatedTradeLayoutRouteWithChildren
  authenticatedVerificationLayoutRoute: typeof authenticatedVerificationLayoutRouteWithChildren
  authenticatedAiInsightsRouteRoute: typeof authenticatedAiInsightsRouteRoute
  authenticatedProductsExploreRouteRoute: typeof authenticatedProductsExploreRouteRoute
  authenticatedSettingsRouteRoute: typeof authenticatedSettingsRouteRoute
  authenticatedProductsDetailsRouteRoute: typeof authenticatedProductsDetailsRouteRoute
  authenticatedSettingsLoginMethodRouteRoute: typeof authenticatedSettingsLoginMethodRouteRoute
  authenticatedSettingsTwoFactorRouteRoute: typeof authenticatedSettingsTwoFactorRouteRoute
  authenticatedSettingsUpdatePasswordRouteRoute: typeof authenticatedSettingsUpdatePasswordRouteRoute
  authenticatedFundsDepositRouteRoute: typeof authenticatedFundsDepositRouteRoute
  authenticatedFundsWithdrawRouteRoute: typeof authenticatedFundsWithdrawRouteRoute
  authenticatedSettingsOtpEnableRouteRoute: typeof authenticatedSettingsOtpEnableRouteRoute
  authenticatedFundsDepositCryptoRouteRoute: typeof authenticatedFundsDepositCryptoRouteRoute
  authenticatedFundsDepositFiatRouteRoute: typeof authenticatedFundsDepositFiatRouteRoute
  authenticatedFundsDepositCryptoProductCodeRouteRoute: typeof authenticatedFundsDepositCryptoProductCodeRouteRoute
  authenticatedFundsDepositFiatBankRouteRoute: typeof authenticatedFundsDepositFiatBankRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeRouteRoute
  authenticatedFundsWithdrawFiatProductCodeRouteRoute: typeof authenticatedFundsWithdrawFiatProductCodeRouteRoute
  authenticatedFundsDepositCryptoProductCodeAddressRouteRoute: typeof authenticatedFundsDepositCryptoProductCodeAddressRouteRoute
  authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute: typeof authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute
  authenticatedFundsDepositFiatBankPopRouteRoute: typeof authenticatedFundsDepositFiatBankPopRouteRoute
  authenticatedFundsWithdrawCryptoProductCode2faRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCode2faRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute
  authenticatedFundsWithdrawFiatProductCode2faRouteRoute: typeof authenticatedFundsWithdrawFiatProductCode2faRouteRoute
  authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute: typeof authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute
  authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute: typeof authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute
  authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute: typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute
  authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute: typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute
  authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute: typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute
}

const authenticatedLayoutRouteChildren: authenticatedLayoutRouteChildren = {
  authenticatedActivityRouteRoute: authenticatedActivityRouteRoute,
  authenticatedNotFoundRouteRoute: authenticatedNotFoundRouteRoute,
  authenticatedPortfolioRouteRoute: authenticatedPortfolioRouteRoute,
  authenticatedRecurringBuysRouteRoute: authenticatedRecurringBuysRouteRoute,
  authenticatedRewardsRouteRoute: authenticatedRewardsRouteRoute,
  authenticatedTaxInformationLayoutRoute:
    authenticatedTaxInformationLayoutRouteWithChildren,
  authenticatedTradeLayoutRoute: authenticatedTradeLayoutRouteWithChildren,
  authenticatedVerificationLayoutRoute:
    authenticatedVerificationLayoutRouteWithChildren,
  authenticatedAiInsightsRouteRoute: authenticatedAiInsightsRouteRoute,
  authenticatedProductsExploreRouteRoute:
    authenticatedProductsExploreRouteRoute,
  authenticatedSettingsRouteRoute: authenticatedSettingsRouteRoute,
  authenticatedProductsDetailsRouteRoute:
    authenticatedProductsDetailsRouteRoute,
  authenticatedSettingsLoginMethodRouteRoute:
    authenticatedSettingsLoginMethodRouteRoute,
  authenticatedSettingsTwoFactorRouteRoute:
    authenticatedSettingsTwoFactorRouteRoute,
  authenticatedSettingsUpdatePasswordRouteRoute:
    authenticatedSettingsUpdatePasswordRouteRoute,
  authenticatedFundsDepositRouteRoute: authenticatedFundsDepositRouteRoute,
  authenticatedFundsWithdrawRouteRoute: authenticatedFundsWithdrawRouteRoute,
  authenticatedSettingsOtpEnableRouteRoute:
    authenticatedSettingsOtpEnableRouteRoute,
  authenticatedFundsDepositCryptoRouteRoute:
    authenticatedFundsDepositCryptoRouteRoute,
  authenticatedFundsDepositFiatRouteRoute:
    authenticatedFundsDepositFiatRouteRoute,
  authenticatedFundsDepositCryptoProductCodeRouteRoute:
    authenticatedFundsDepositCryptoProductCodeRouteRoute,
  authenticatedFundsDepositFiatBankRouteRoute:
    authenticatedFundsDepositFiatBankRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeRouteRoute,
  authenticatedFundsWithdrawFiatProductCodeRouteRoute:
    authenticatedFundsWithdrawFiatProductCodeRouteRoute,
  authenticatedFundsDepositCryptoProductCodeAddressRouteRoute:
    authenticatedFundsDepositCryptoProductCodeAddressRouteRoute,
  authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute:
    authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute,
  authenticatedFundsDepositFiatBankPopRouteRoute:
    authenticatedFundsDepositFiatBankPopRouteRoute,
  authenticatedFundsWithdrawCryptoProductCode2faRouteRoute:
    authenticatedFundsWithdrawCryptoProductCode2faRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute,
  authenticatedFundsWithdrawFiatProductCode2faRouteRoute:
    authenticatedFundsWithdrawFiatProductCode2faRouteRoute,
  authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute:
    authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute,
  authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute:
    authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute,
  authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute:
    authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute,
  authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute:
    authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute,
  authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute:
    authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute,
}

const authenticatedLayoutRouteWithChildren =
  authenticatedLayoutRoute._addFileChildren(authenticatedLayoutRouteChildren)

interface authLoginLayoutRouteChildren {
  authLoginRouteRoute: typeof authLoginRouteRoute
  authLogin2faRouteRoute: typeof authLogin2faRouteRoute
}

const authLoginLayoutRouteChildren: authLoginLayoutRouteChildren = {
  authLoginRouteRoute: authLoginRouteRoute,
  authLogin2faRouteRoute: authLogin2faRouteRoute,
}

const authLoginLayoutRouteWithChildren = authLoginLayoutRoute._addFileChildren(
  authLoginLayoutRouteChildren,
)

interface authResetPasswordLayoutRouteChildren {
  authResetPasswordRouteRoute: typeof authResetPasswordRouteRoute
  authResetPasswordCompletedRouteRoute: typeof authResetPasswordCompletedRouteRoute
  authResetPasswordRequestRouteRoute: typeof authResetPasswordRequestRouteRoute
  authResetPasswordSentRouteRoute: typeof authResetPasswordSentRouteRoute
}

const authResetPasswordLayoutRouteChildren: authResetPasswordLayoutRouteChildren =
  {
    authResetPasswordRouteRoute: authResetPasswordRouteRoute,
    authResetPasswordCompletedRouteRoute: authResetPasswordCompletedRouteRoute,
    authResetPasswordRequestRouteRoute: authResetPasswordRequestRouteRoute,
    authResetPasswordSentRouteRoute: authResetPasswordSentRouteRoute,
  }

const authResetPasswordLayoutRouteWithChildren =
  authResetPasswordLayoutRoute._addFileChildren(
    authResetPasswordLayoutRouteChildren,
  )

interface AuthResetTwoFactorRouteChildren {
  authResetTwoFactorSubmittedRouteRoute: typeof authResetTwoFactorSubmittedRouteRoute
}

const AuthResetTwoFactorRouteChildren: AuthResetTwoFactorRouteChildren = {
  authResetTwoFactorSubmittedRouteRoute: authResetTwoFactorSubmittedRouteRoute,
}

const AuthResetTwoFactorRouteWithChildren =
  AuthResetTwoFactorRoute._addFileChildren(AuthResetTwoFactorRouteChildren)

interface authResetTwoFactorLayoutRouteChildren {
  authResetTwoFactorRouteRoute: typeof authResetTwoFactorRouteRoute
  AuthResetTwoFactorRoute: typeof AuthResetTwoFactorRouteWithChildren
}

const authResetTwoFactorLayoutRouteChildren: authResetTwoFactorLayoutRouteChildren =
  {
    authResetTwoFactorRouteRoute: authResetTwoFactorRouteRoute,
    AuthResetTwoFactorRoute: AuthResetTwoFactorRouteWithChildren,
  }

const authResetTwoFactorLayoutRouteWithChildren =
  authResetTwoFactorLayoutRoute._addFileChildren(
    authResetTwoFactorLayoutRouteChildren,
  )

interface authSignupAuthenticatedLayoutRouteChildren {
  authSignupAuthenticatedAccountDetailsRouteRoute: typeof authSignupAuthenticatedAccountDetailsRouteRoute
  authSignupAuthenticatedTosRouteRoute: typeof authSignupAuthenticatedTosRouteRoute
  authSignupAuthenticatedVerifyEmailRouteRoute: typeof authSignupAuthenticatedVerifyEmailRouteRoute
  authSignupAuthenticatedWelcomeRouteRoute: typeof authSignupAuthenticatedWelcomeRouteRoute
}

const authSignupAuthenticatedLayoutRouteChildren: authSignupAuthenticatedLayoutRouteChildren =
  {
    authSignupAuthenticatedAccountDetailsRouteRoute:
      authSignupAuthenticatedAccountDetailsRouteRoute,
    authSignupAuthenticatedTosRouteRoute: authSignupAuthenticatedTosRouteRoute,
    authSignupAuthenticatedVerifyEmailRouteRoute:
      authSignupAuthenticatedVerifyEmailRouteRoute,
    authSignupAuthenticatedWelcomeRouteRoute:
      authSignupAuthenticatedWelcomeRouteRoute,
  }

const authSignupAuthenticatedLayoutRouteWithChildren =
  authSignupAuthenticatedLayoutRoute._addFileChildren(
    authSignupAuthenticatedLayoutRouteChildren,
  )

interface authSignupLayoutRouteChildren {
  authSignupCheckEmailRouteRoute: typeof authSignupCheckEmailRouteRoute
  authSignupAuthenticatedLayoutRoute: typeof authSignupAuthenticatedLayoutRouteWithChildren
  authSignupIndexRoute: typeof authSignupIndexRoute
}

const authSignupLayoutRouteChildren: authSignupLayoutRouteChildren = {
  authSignupCheckEmailRouteRoute: authSignupCheckEmailRouteRoute,
  authSignupAuthenticatedLayoutRoute:
    authSignupAuthenticatedLayoutRouteWithChildren,
  authSignupIndexRoute: authSignupIndexRoute,
}

const authSignupLayoutRouteWithChildren =
  authSignupLayoutRoute._addFileChildren(authSignupLayoutRouteChildren)

interface authLayoutRouteChildren {
  authLoginLayoutRoute: typeof authLoginLayoutRouteWithChildren
  authResetPasswordLayoutRoute: typeof authResetPasswordLayoutRouteWithChildren
  authResetTwoFactorLayoutRoute: typeof authResetTwoFactorLayoutRouteWithChildren
  authSignupLayoutRoute: typeof authSignupLayoutRouteWithChildren
}

const authLayoutRouteChildren: authLayoutRouteChildren = {
  authLoginLayoutRoute: authLoginLayoutRouteWithChildren,
  authResetPasswordLayoutRoute: authResetPasswordLayoutRouteWithChildren,
  authResetTwoFactorLayoutRoute: authResetTwoFactorLayoutRouteWithChildren,
  authSignupLayoutRoute: authSignupLayoutRouteWithChildren,
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(
  authLayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof routeRoute
  '/register': typeof registerRouteRoute
  '': typeof authenticatedLayoutRouteWithChildren
  '/auth': typeof authLayoutRouteWithChildren
  '/activity': typeof authenticatedActivityRouteRoute
  '/not-found': typeof authenticatedNotFoundRouteRoute
  '/portfolio': typeof authenticatedPortfolioRouteRoute
  '/recurring-buys': typeof authenticatedRecurringBuysRouteRoute
  '/rewards': typeof authenticatedRewardsRouteRoute
  '/reset-password/resetPassword': typeof resetPasswordRouteRoute
  '/tax-information': typeof authenticatedTaxInformationLayoutRouteWithChildren
  '/trade': typeof authenticatedTradeLayoutRouteWithChildren
  '/verification': typeof authenticatedVerificationLayoutRouteWithChildren
  '/auth/login': typeof authLoginLayoutRouteWithChildren
  '/auth/reset-password': typeof authResetPasswordLayoutRouteWithChildren
  '/auth/reset-two-factor': typeof AuthResetTwoFactorRouteWithChildren
  '/auth/signup': typeof authSignupAuthenticatedLayoutRouteWithChildren
  '/ai-insights': typeof authenticatedAiInsightsRouteRoute
  '/products': typeof authenticatedProductsExploreRouteRoute
  '/settings': typeof authenticatedSettingsRouteRoute
  '/tax-information/': typeof authenticatedTaxInformationAddCountryOfResidenceRouteRoute
  '/auth/login/': typeof authLoginRouteRoute
  '/auth/reset-password/': typeof authResetPasswordRouteRoute
  '/auth/reset-two-factor/': typeof authResetTwoFactorRouteRoute
  '/products/$productCode': typeof authenticatedProductsDetailsRouteRoute
  '/settings/login-method': typeof authenticatedSettingsLoginMethodRouteRoute
  '/settings/two-factor': typeof authenticatedSettingsTwoFactorRouteRoute
  '/settings/update-password': typeof authenticatedSettingsUpdatePasswordRouteRoute
  '/tax-information/add-country-of-tax-residence': typeof authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute
  '/tax-information/add-home-address': typeof authenticatedTaxInformationAddHomeAddressRouteRoute
  '/tax-information/add-tax-identification-number': typeof authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute
  '/tax-information/edit-tax-information': typeof authenticatedTaxInformationEditTaxInformationRouteRoute
  '/tax-information/review-tax-information': typeof authenticatedTaxInformationReviewTaxInformationRouteRoute
  '/trade/buy-now': typeof authenticatedTradeBuyNowRouteRoute
  '/trade/recurring-buy': typeof authenticatedTradeRecurringBuyRouteRoute
  '/trade/sell-now': typeof authenticatedTradeSellNowRouteRoute
  '/verification/error': typeof authenticatedVerificationErrorRouteRoute
  '/verification/kyc': typeof authenticatedVerificationKycRouteRoute
  '/verification/submitted': typeof authenticatedVerificationSubmittedRouteRoute
  '/auth/login/2fa': typeof authLogin2faRouteRoute
  '/auth/reset-password/completed': typeof authResetPasswordCompletedRouteRoute
  '/auth/reset-password/request': typeof authResetPasswordRequestRouteRoute
  '/auth/reset-password/sent': typeof authResetPasswordSentRouteRoute
  '/auth/signup/check-email': typeof authSignupCheckEmailRouteRoute
  '/verification/': typeof authenticatedVerificationIndexRoute
  '/auth/signup/': typeof authSignupIndexRoute
  '/funds/deposit': typeof authenticatedFundsDepositRouteRoute
  '/funds/withdraw': typeof authenticatedFundsWithdrawRouteRoute
  '/settings/otp/enable': typeof authenticatedSettingsOtpEnableRouteRoute
  '/auth/reset-two-factor/submitted': typeof authResetTwoFactorSubmittedRouteRoute
  '/auth/signup/account-details': typeof authSignupAuthenticatedAccountDetailsRouteRoute
  '/auth/signup/tos': typeof authSignupAuthenticatedTosRouteRoute
  '/auth/signup/verify-email': typeof authSignupAuthenticatedVerifyEmailRouteRoute
  '/auth/signup/welcome': typeof authSignupAuthenticatedWelcomeRouteRoute
  '/funds/deposit/crypto': typeof authenticatedFundsDepositCryptoRouteRoute
  '/funds/deposit/fiat': typeof authenticatedFundsDepositFiatRouteRoute
  '/funds/deposit/crypto/$productCode': typeof authenticatedFundsDepositCryptoProductCodeRouteRoute
  '/funds/deposit/fiat/bank': typeof authenticatedFundsDepositFiatBankRouteRoute
  '/funds/withdraw/crypto/$productCode': typeof authenticatedFundsWithdrawCryptoProductCodeRouteRoute
  '/funds/withdraw/fiat/$productCode': typeof authenticatedFundsWithdrawFiatProductCodeRouteRoute
  '/funds/deposit/crypto/$productCode/address': typeof authenticatedFundsDepositCryptoProductCodeAddressRouteRoute
  '/funds/deposit/crypto/$productCode/complete': typeof authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute
  '/funds/deposit/fiat/bank/pop': typeof authenticatedFundsDepositFiatBankPopRouteRoute
  '/funds/withdraw/crypto/$productCode/2fa': typeof authenticatedFundsWithdrawCryptoProductCode2faRouteRoute
  '/funds/withdraw/crypto/$productCode/complete': typeof authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute
  '/funds/withdraw/crypto/$productCode/otp': typeof authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute
  '/funds/withdraw/fiat/$productCode/2fa': typeof authenticatedFundsWithdrawFiatProductCode2faRouteRoute
  '/funds/withdraw/fiat/$productCode/complete': typeof authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute
  '/funds/withdraw/fiat/$productCode/otp': typeof authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute
  '/funds/withdraw/crypto/$productCode/disclaimer/accept': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute
  '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/verify': typeof authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute
  '/funds/withdraw/fiat/$productCode/bank-details/edit': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute
  '/funds/withdraw/fiat/$productCode/bank-details/review': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/confirm': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/details': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/otp': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute
}

export interface FileRoutesByTo {
  '/': typeof routeRoute
  '/register': typeof registerRouteRoute
  '': typeof authenticatedLayoutRouteWithChildren
  '/auth': typeof authLayoutRouteWithChildren
  '/activity': typeof authenticatedActivityRouteRoute
  '/not-found': typeof authenticatedNotFoundRouteRoute
  '/portfolio': typeof authenticatedPortfolioRouteRoute
  '/recurring-buys': typeof authenticatedRecurringBuysRouteRoute
  '/rewards': typeof authenticatedRewardsRouteRoute
  '/reset-password/resetPassword': typeof resetPasswordRouteRoute
  '/trade': typeof authenticatedTradeLayoutRouteWithChildren
  '/ai-insights': typeof authenticatedAiInsightsRouteRoute
  '/products': typeof authenticatedProductsExploreRouteRoute
  '/settings': typeof authenticatedSettingsRouteRoute
  '/tax-information': typeof authenticatedTaxInformationAddCountryOfResidenceRouteRoute
  '/auth/login': typeof authLoginRouteRoute
  '/auth/reset-password': typeof authResetPasswordRouteRoute
  '/auth/reset-two-factor': typeof AuthResetTwoFactorRouteWithChildren
  '/products/$productCode': typeof authenticatedProductsDetailsRouteRoute
  '/settings/login-method': typeof authenticatedSettingsLoginMethodRouteRoute
  '/settings/two-factor': typeof authenticatedSettingsTwoFactorRouteRoute
  '/settings/update-password': typeof authenticatedSettingsUpdatePasswordRouteRoute
  '/tax-information/add-country-of-tax-residence': typeof authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute
  '/tax-information/add-home-address': typeof authenticatedTaxInformationAddHomeAddressRouteRoute
  '/tax-information/add-tax-identification-number': typeof authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute
  '/tax-information/edit-tax-information': typeof authenticatedTaxInformationEditTaxInformationRouteRoute
  '/tax-information/review-tax-information': typeof authenticatedTaxInformationReviewTaxInformationRouteRoute
  '/trade/buy-now': typeof authenticatedTradeBuyNowRouteRoute
  '/trade/recurring-buy': typeof authenticatedTradeRecurringBuyRouteRoute
  '/trade/sell-now': typeof authenticatedTradeSellNowRouteRoute
  '/verification/error': typeof authenticatedVerificationErrorRouteRoute
  '/verification/kyc': typeof authenticatedVerificationKycRouteRoute
  '/verification/submitted': typeof authenticatedVerificationSubmittedRouteRoute
  '/auth/login/2fa': typeof authLogin2faRouteRoute
  '/auth/reset-password/completed': typeof authResetPasswordCompletedRouteRoute
  '/auth/reset-password/request': typeof authResetPasswordRequestRouteRoute
  '/auth/reset-password/sent': typeof authResetPasswordSentRouteRoute
  '/auth/signup/check-email': typeof authSignupCheckEmailRouteRoute
  '/auth/signup': typeof authSignupIndexRoute
  '/verification': typeof authenticatedVerificationIndexRoute
  '/funds/deposit': typeof authenticatedFundsDepositRouteRoute
  '/funds/withdraw': typeof authenticatedFundsWithdrawRouteRoute
  '/settings/otp/enable': typeof authenticatedSettingsOtpEnableRouteRoute
  '/auth/reset-two-factor/submitted': typeof authResetTwoFactorSubmittedRouteRoute
  '/auth/signup/account-details': typeof authSignupAuthenticatedAccountDetailsRouteRoute
  '/auth/signup/tos': typeof authSignupAuthenticatedTosRouteRoute
  '/auth/signup/verify-email': typeof authSignupAuthenticatedVerifyEmailRouteRoute
  '/auth/signup/welcome': typeof authSignupAuthenticatedWelcomeRouteRoute
  '/funds/deposit/crypto': typeof authenticatedFundsDepositCryptoRouteRoute
  '/funds/deposit/fiat': typeof authenticatedFundsDepositFiatRouteRoute
  '/funds/deposit/crypto/$productCode': typeof authenticatedFundsDepositCryptoProductCodeRouteRoute
  '/funds/deposit/fiat/bank': typeof authenticatedFundsDepositFiatBankRouteRoute
  '/funds/withdraw/crypto/$productCode': typeof authenticatedFundsWithdrawCryptoProductCodeRouteRoute
  '/funds/withdraw/fiat/$productCode': typeof authenticatedFundsWithdrawFiatProductCodeRouteRoute
  '/funds/deposit/crypto/$productCode/address': typeof authenticatedFundsDepositCryptoProductCodeAddressRouteRoute
  '/funds/deposit/crypto/$productCode/complete': typeof authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute
  '/funds/deposit/fiat/bank/pop': typeof authenticatedFundsDepositFiatBankPopRouteRoute
  '/funds/withdraw/crypto/$productCode/2fa': typeof authenticatedFundsWithdrawCryptoProductCode2faRouteRoute
  '/funds/withdraw/crypto/$productCode/complete': typeof authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute
  '/funds/withdraw/crypto/$productCode/otp': typeof authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute
  '/funds/withdraw/fiat/$productCode/2fa': typeof authenticatedFundsWithdrawFiatProductCode2faRouteRoute
  '/funds/withdraw/fiat/$productCode/complete': typeof authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute
  '/funds/withdraw/fiat/$productCode/otp': typeof authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute
  '/funds/withdraw/crypto/$productCode/disclaimer/accept': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute
  '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/verify': typeof authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute
  '/funds/withdraw/fiat/$productCode/bank-details/edit': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute
  '/funds/withdraw/fiat/$productCode/bank-details/review': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/confirm': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/details': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/otp': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute
  '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof routeRoute
  '/register': typeof registerRouteRoute
  '/_authenticated': typeof authenticatedLayoutRouteWithChildren
  '/auth': typeof authLayoutRouteWithChildren
  '/_authenticated/activity': typeof authenticatedActivityRouteRoute
  '/_authenticated/not-found': typeof authenticatedNotFoundRouteRoute
  '/_authenticated/portfolio': typeof authenticatedPortfolioRouteRoute
  '/_authenticated/recurring-buys': typeof authenticatedRecurringBuysRouteRoute
  '/_authenticated/rewards': typeof authenticatedRewardsRouteRoute
  '/reset-password/resetPassword': typeof resetPasswordRouteRoute
  '/_authenticated/tax-information': typeof authenticatedTaxInformationLayoutRouteWithChildren
  '/_authenticated/trade': typeof authenticatedTradeLayoutRouteWithChildren
  '/_authenticated/verification': typeof authenticatedVerificationLayoutRouteWithChildren
  '/auth/login': typeof authLoginLayoutRouteWithChildren
  '/auth/reset-password': typeof authResetPasswordLayoutRouteWithChildren
  '/auth/reset-two-factor': typeof authResetTwoFactorLayoutRouteWithChildren
  '/auth/signup': typeof authSignupLayoutRouteWithChildren
  '/_authenticated/ai-insights/': typeof authenticatedAiInsightsRouteRoute
  '/_authenticated/products/': typeof authenticatedProductsExploreRouteRoute
  '/_authenticated/settings/': typeof authenticatedSettingsRouteRoute
  '/_authenticated/tax-information/': typeof authenticatedTaxInformationAddCountryOfResidenceRouteRoute
  '/auth/login/': typeof authLoginRouteRoute
  '/auth/reset-password/': typeof authResetPasswordRouteRoute
  '/auth/reset-two-factor/': typeof authResetTwoFactorRouteRoute
  '/_authenticated/products/$productCode': typeof authenticatedProductsDetailsRouteRoute
  '/_authenticated/settings/login-method': typeof authenticatedSettingsLoginMethodRouteRoute
  '/_authenticated/settings/two-factor': typeof authenticatedSettingsTwoFactorRouteRoute
  '/_authenticated/settings/update-password': typeof authenticatedSettingsUpdatePasswordRouteRoute
  '/_authenticated/tax-information/add-country-of-tax-residence': typeof authenticatedTaxInformationAddCountryOfTaxResidenceRouteRoute
  '/_authenticated/tax-information/add-home-address': typeof authenticatedTaxInformationAddHomeAddressRouteRoute
  '/_authenticated/tax-information/add-tax-identification-number': typeof authenticatedTaxInformationAddTaxIdentificationNumberRouteRoute
  '/_authenticated/tax-information/edit-tax-information': typeof authenticatedTaxInformationEditTaxInformationRouteRoute
  '/_authenticated/tax-information/review-tax-information': typeof authenticatedTaxInformationReviewTaxInformationRouteRoute
  '/_authenticated/trade/buy-now': typeof authenticatedTradeBuyNowRouteRoute
  '/_authenticated/trade/recurring-buy': typeof authenticatedTradeRecurringBuyRouteRoute
  '/_authenticated/trade/sell-now': typeof authenticatedTradeSellNowRouteRoute
  '/_authenticated/verification/error': typeof authenticatedVerificationErrorRouteRoute
  '/_authenticated/verification/kyc': typeof authenticatedVerificationKycRouteRoute
  '/_authenticated/verification/submitted': typeof authenticatedVerificationSubmittedRouteRoute
  '/auth/login/2fa': typeof authLogin2faRouteRoute
  '/auth/reset-password/completed': typeof authResetPasswordCompletedRouteRoute
  '/auth/reset-password/request': typeof authResetPasswordRequestRouteRoute
  '/auth/reset-password/sent': typeof authResetPasswordSentRouteRoute
  '/auth/signup/check-email': typeof authSignupCheckEmailRouteRoute
  '/auth/signup/_layout': typeof authSignupAuthenticatedLayoutRouteWithChildren
  '/_authenticated/verification/': typeof authenticatedVerificationIndexRoute
  '/auth/signup/': typeof authSignupIndexRoute
  '/_authenticated/funds/deposit/': typeof authenticatedFundsDepositRouteRoute
  '/_authenticated/funds/withdraw/': typeof authenticatedFundsWithdrawRouteRoute
  '/_authenticated/settings/otp/enable': typeof authenticatedSettingsOtpEnableRouteRoute
  '/auth/reset-two-factor/_': typeof AuthResetTwoFactorRouteWithChildren
  '/auth/reset-two-factor/_/submitted': typeof authResetTwoFactorSubmittedRouteRoute
  '/auth/signup/_layout/account-details': typeof authSignupAuthenticatedAccountDetailsRouteRoute
  '/auth/signup/_layout/tos': typeof authSignupAuthenticatedTosRouteRoute
  '/auth/signup/_layout/verify-email': typeof authSignupAuthenticatedVerifyEmailRouteRoute
  '/auth/signup/_layout/welcome': typeof authSignupAuthenticatedWelcomeRouteRoute
  '/_authenticated/funds/deposit/crypto/': typeof authenticatedFundsDepositCryptoRouteRoute
  '/_authenticated/funds/deposit/fiat/': typeof authenticatedFundsDepositFiatRouteRoute
  '/_authenticated/funds/deposit/crypto/$productCode/': typeof authenticatedFundsDepositCryptoProductCodeRouteRoute
  '/_authenticated/funds/deposit/fiat/bank/': typeof authenticatedFundsDepositFiatBankRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/': typeof authenticatedFundsWithdrawCryptoProductCodeRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/': typeof authenticatedFundsWithdrawFiatProductCodeRouteRoute
  '/_authenticated/funds/deposit/crypto/$productCode/address': typeof authenticatedFundsDepositCryptoProductCodeAddressRouteRoute
  '/_authenticated/funds/deposit/crypto/$productCode/complete': typeof authenticatedFundsDepositCryptoProductCodeCompleteRouteRoute
  '/_authenticated/funds/deposit/fiat/bank/pop': typeof authenticatedFundsDepositFiatBankPopRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/2fa': typeof authenticatedFundsWithdrawCryptoProductCode2faRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/complete': typeof authenticatedFundsWithdrawCryptoProductCodeCompleteRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/otp': typeof authenticatedFundsWithdrawCryptoProductCodeOtpRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/2fa': typeof authenticatedFundsWithdrawFiatProductCode2faRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/complete': typeof authenticatedFundsWithdrawFiatProductCodeCompleteRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/otp': typeof authenticatedFundsWithdrawFiatProductCodeOtpRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcceptRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge': typeof authenticatedFundsWithdrawCryptoProductCodeDisclaimerAcknowledgeRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify': typeof authenticatedFundsWithdrawCryptoProductCodeWalletVerifyRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsEditRouteRoute
  '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review': typeof authenticatedFundsWithdrawFiatProductCodeBankDetailsReviewRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditConfirmRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditDetailsRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditOtpRouteRoute
  '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule': typeof authenticatedFundsWithdrawCryptoProductCodeWalletEditTravelRuleRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/register'
    | ''
    | '/auth'
    | '/activity'
    | '/not-found'
    | '/portfolio'
    | '/recurring-buys'
    | '/rewards'
    | '/reset-password/resetPassword'
    | '/tax-information'
    | '/trade'
    | '/verification'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-two-factor'
    | '/auth/signup'
    | '/ai-insights'
    | '/products'
    | '/settings'
    | '/tax-information/'
    | '/auth/login/'
    | '/auth/reset-password/'
    | '/auth/reset-two-factor/'
    | '/products/$productCode'
    | '/settings/login-method'
    | '/settings/two-factor'
    | '/settings/update-password'
    | '/tax-information/add-country-of-tax-residence'
    | '/tax-information/add-home-address'
    | '/tax-information/add-tax-identification-number'
    | '/tax-information/edit-tax-information'
    | '/tax-information/review-tax-information'
    | '/trade/buy-now'
    | '/trade/recurring-buy'
    | '/trade/sell-now'
    | '/verification/error'
    | '/verification/kyc'
    | '/verification/submitted'
    | '/auth/login/2fa'
    | '/auth/reset-password/completed'
    | '/auth/reset-password/request'
    | '/auth/reset-password/sent'
    | '/auth/signup/check-email'
    | '/verification/'
    | '/auth/signup/'
    | '/funds/deposit'
    | '/funds/withdraw'
    | '/settings/otp/enable'
    | '/auth/reset-two-factor/submitted'
    | '/auth/signup/account-details'
    | '/auth/signup/tos'
    | '/auth/signup/verify-email'
    | '/auth/signup/welcome'
    | '/funds/deposit/crypto'
    | '/funds/deposit/fiat'
    | '/funds/deposit/crypto/$productCode'
    | '/funds/deposit/fiat/bank'
    | '/funds/withdraw/crypto/$productCode'
    | '/funds/withdraw/fiat/$productCode'
    | '/funds/deposit/crypto/$productCode/address'
    | '/funds/deposit/crypto/$productCode/complete'
    | '/funds/deposit/fiat/bank/pop'
    | '/funds/withdraw/crypto/$productCode/2fa'
    | '/funds/withdraw/crypto/$productCode/complete'
    | '/funds/withdraw/crypto/$productCode/otp'
    | '/funds/withdraw/fiat/$productCode/2fa'
    | '/funds/withdraw/fiat/$productCode/complete'
    | '/funds/withdraw/fiat/$productCode/otp'
    | '/funds/withdraw/crypto/$productCode/disclaimer/accept'
    | '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
    | '/funds/withdraw/crypto/$productCode/wallet/verify'
    | '/funds/withdraw/fiat/$productCode/bank-details/edit'
    | '/funds/withdraw/fiat/$productCode/bank-details/review'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/details'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/otp'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/register'
    | ''
    | '/auth'
    | '/activity'
    | '/not-found'
    | '/portfolio'
    | '/recurring-buys'
    | '/rewards'
    | '/reset-password/resetPassword'
    | '/trade'
    | '/ai-insights'
    | '/products'
    | '/settings'
    | '/tax-information'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-two-factor'
    | '/products/$productCode'
    | '/settings/login-method'
    | '/settings/two-factor'
    | '/settings/update-password'
    | '/tax-information/add-country-of-tax-residence'
    | '/tax-information/add-home-address'
    | '/tax-information/add-tax-identification-number'
    | '/tax-information/edit-tax-information'
    | '/tax-information/review-tax-information'
    | '/trade/buy-now'
    | '/trade/recurring-buy'
    | '/trade/sell-now'
    | '/verification/error'
    | '/verification/kyc'
    | '/verification/submitted'
    | '/auth/login/2fa'
    | '/auth/reset-password/completed'
    | '/auth/reset-password/request'
    | '/auth/reset-password/sent'
    | '/auth/signup/check-email'
    | '/auth/signup'
    | '/verification'
    | '/funds/deposit'
    | '/funds/withdraw'
    | '/settings/otp/enable'
    | '/auth/reset-two-factor/submitted'
    | '/auth/signup/account-details'
    | '/auth/signup/tos'
    | '/auth/signup/verify-email'
    | '/auth/signup/welcome'
    | '/funds/deposit/crypto'
    | '/funds/deposit/fiat'
    | '/funds/deposit/crypto/$productCode'
    | '/funds/deposit/fiat/bank'
    | '/funds/withdraw/crypto/$productCode'
    | '/funds/withdraw/fiat/$productCode'
    | '/funds/deposit/crypto/$productCode/address'
    | '/funds/deposit/crypto/$productCode/complete'
    | '/funds/deposit/fiat/bank/pop'
    | '/funds/withdraw/crypto/$productCode/2fa'
    | '/funds/withdraw/crypto/$productCode/complete'
    | '/funds/withdraw/crypto/$productCode/otp'
    | '/funds/withdraw/fiat/$productCode/2fa'
    | '/funds/withdraw/fiat/$productCode/complete'
    | '/funds/withdraw/fiat/$productCode/otp'
    | '/funds/withdraw/crypto/$productCode/disclaimer/accept'
    | '/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
    | '/funds/withdraw/crypto/$productCode/wallet/verify'
    | '/funds/withdraw/fiat/$productCode/bank-details/edit'
    | '/funds/withdraw/fiat/$productCode/bank-details/review'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/details'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/otp'
    | '/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
  id:
    | '__root__'
    | '/'
    | '/register'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/activity'
    | '/_authenticated/not-found'
    | '/_authenticated/portfolio'
    | '/_authenticated/recurring-buys'
    | '/_authenticated/rewards'
    | '/reset-password/resetPassword'
    | '/_authenticated/tax-information'
    | '/_authenticated/trade'
    | '/_authenticated/verification'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-two-factor'
    | '/auth/signup'
    | '/_authenticated/ai-insights/'
    | '/_authenticated/products/'
    | '/_authenticated/settings/'
    | '/_authenticated/tax-information/'
    | '/auth/login/'
    | '/auth/reset-password/'
    | '/auth/reset-two-factor/'
    | '/_authenticated/products/$productCode'
    | '/_authenticated/settings/login-method'
    | '/_authenticated/settings/two-factor'
    | '/_authenticated/settings/update-password'
    | '/_authenticated/tax-information/add-country-of-tax-residence'
    | '/_authenticated/tax-information/add-home-address'
    | '/_authenticated/tax-information/add-tax-identification-number'
    | '/_authenticated/tax-information/edit-tax-information'
    | '/_authenticated/tax-information/review-tax-information'
    | '/_authenticated/trade/buy-now'
    | '/_authenticated/trade/recurring-buy'
    | '/_authenticated/trade/sell-now'
    | '/_authenticated/verification/error'
    | '/_authenticated/verification/kyc'
    | '/_authenticated/verification/submitted'
    | '/auth/login/2fa'
    | '/auth/reset-password/completed'
    | '/auth/reset-password/request'
    | '/auth/reset-password/sent'
    | '/auth/signup/check-email'
    | '/auth/signup/_layout'
    | '/_authenticated/verification/'
    | '/auth/signup/'
    | '/_authenticated/funds/deposit/'
    | '/_authenticated/funds/withdraw/'
    | '/_authenticated/settings/otp/enable'
    | '/auth/reset-two-factor/_'
    | '/auth/reset-two-factor/_/submitted'
    | '/auth/signup/_layout/account-details'
    | '/auth/signup/_layout/tos'
    | '/auth/signup/_layout/verify-email'
    | '/auth/signup/_layout/welcome'
    | '/_authenticated/funds/deposit/crypto/'
    | '/_authenticated/funds/deposit/fiat/'
    | '/_authenticated/funds/deposit/crypto/$productCode/'
    | '/_authenticated/funds/deposit/fiat/bank/'
    | '/_authenticated/funds/withdraw/crypto/$productCode/'
    | '/_authenticated/funds/withdraw/fiat/$productCode/'
    | '/_authenticated/funds/deposit/crypto/$productCode/address'
    | '/_authenticated/funds/deposit/crypto/$productCode/complete'
    | '/_authenticated/funds/deposit/fiat/bank/pop'
    | '/_authenticated/funds/withdraw/crypto/$productCode/2fa'
    | '/_authenticated/funds/withdraw/crypto/$productCode/complete'
    | '/_authenticated/funds/withdraw/crypto/$productCode/otp'
    | '/_authenticated/funds/withdraw/fiat/$productCode/2fa'
    | '/_authenticated/funds/withdraw/fiat/$productCode/complete'
    | '/_authenticated/funds/withdraw/fiat/$productCode/otp'
    | '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept'
    | '/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge'
    | '/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify'
    | '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit'
    | '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review'
    | '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm'
    | '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details'
    | '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp'
    | '/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  routeRoute: typeof routeRoute
  registerRouteRoute: typeof registerRouteRoute
  authenticatedLayoutRoute: typeof authenticatedLayoutRouteWithChildren
  authLayoutRoute: typeof authLayoutRouteWithChildren
  resetPasswordRouteRoute: typeof resetPasswordRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  routeRoute: routeRoute,
  registerRouteRoute: registerRouteRoute,
  authenticatedLayoutRoute: authenticatedLayoutRouteWithChildren,
  authLayoutRoute: authLayoutRouteWithChildren,
  resetPasswordRouteRoute: resetPasswordRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/register",
        "/_authenticated",
        "/auth",
        "/reset-password/resetPassword"
      ]
    },
    "/": {
      "filePath": "route.tsx"
    },
    "/register": {
      "filePath": "register/route.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated/layout.tsx",
      "children": [
        "/_authenticated/activity",
        "/_authenticated/not-found",
        "/_authenticated/portfolio",
        "/_authenticated/recurring-buys",
        "/_authenticated/rewards",
        "/_authenticated/tax-information",
        "/_authenticated/trade",
        "/_authenticated/verification",
        "/_authenticated/ai-insights/",
        "/_authenticated/products/",
        "/_authenticated/settings/",
        "/_authenticated/products/$productCode",
        "/_authenticated/settings/login-method",
        "/_authenticated/settings/two-factor",
        "/_authenticated/settings/update-password",
        "/_authenticated/funds/deposit/",
        "/_authenticated/funds/withdraw/",
        "/_authenticated/settings/otp/enable",
        "/_authenticated/funds/deposit/crypto/",
        "/_authenticated/funds/deposit/fiat/",
        "/_authenticated/funds/deposit/crypto/$productCode/",
        "/_authenticated/funds/deposit/fiat/bank/",
        "/_authenticated/funds/withdraw/crypto/$productCode/",
        "/_authenticated/funds/withdraw/fiat/$productCode/",
        "/_authenticated/funds/deposit/crypto/$productCode/address",
        "/_authenticated/funds/deposit/crypto/$productCode/complete",
        "/_authenticated/funds/deposit/fiat/bank/pop",
        "/_authenticated/funds/withdraw/crypto/$productCode/2fa",
        "/_authenticated/funds/withdraw/crypto/$productCode/complete",
        "/_authenticated/funds/withdraw/crypto/$productCode/otp",
        "/_authenticated/funds/withdraw/fiat/$productCode/2fa",
        "/_authenticated/funds/withdraw/fiat/$productCode/complete",
        "/_authenticated/funds/withdraw/fiat/$productCode/otp",
        "/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept",
        "/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge",
        "/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify",
        "/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit",
        "/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review",
        "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm",
        "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details",
        "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp",
        "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule"
      ]
    },
    "/auth": {
      "filePath": "auth/layout.tsx",
      "children": [
        "/auth/login",
        "/auth/reset-password",
        "/auth/reset-two-factor",
        "/auth/signup"
      ]
    },
    "/_authenticated/activity": {
      "filePath": "_authenticated/activity/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/not-found": {
      "filePath": "_authenticated/not-found/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/portfolio": {
      "filePath": "_authenticated/portfolio/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/recurring-buys": {
      "filePath": "_authenticated/recurring-buys/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/rewards": {
      "filePath": "_authenticated/rewards/route.tsx",
      "parent": "/_authenticated"
    },
    "/reset-password/resetPassword": {
      "filePath": "reset-password/route.tsx"
    },
    "/_authenticated/tax-information": {
      "filePath": "_authenticated/tax-information/layout.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/tax-information/",
        "/_authenticated/tax-information/add-country-of-tax-residence",
        "/_authenticated/tax-information/add-home-address",
        "/_authenticated/tax-information/add-tax-identification-number",
        "/_authenticated/tax-information/edit-tax-information",
        "/_authenticated/tax-information/review-tax-information"
      ]
    },
    "/_authenticated/trade": {
      "filePath": "_authenticated/trade/layout.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/trade/buy-now",
        "/_authenticated/trade/recurring-buy",
        "/_authenticated/trade/sell-now"
      ]
    },
    "/_authenticated/verification": {
      "filePath": "_authenticated/verification/layout.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/verification/error",
        "/_authenticated/verification/kyc",
        "/_authenticated/verification/submitted",
        "/_authenticated/verification/"
      ]
    },
    "/auth/login": {
      "filePath": "auth/login/layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/login/",
        "/auth/login/2fa"
      ]
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password/layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/reset-password/",
        "/auth/reset-password/completed",
        "/auth/reset-password/request",
        "/auth/reset-password/sent"
      ]
    },
    "/auth/reset-two-factor": {
      "filePath": "auth/reset-two-factor/layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/reset-two-factor/",
        "/auth/reset-two-factor/_"
      ]
    },
    "/auth/signup": {
      "filePath": "auth/signup/layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/signup/check-email",
        "/auth/signup/_layout",
        "/auth/signup/"
      ]
    },
    "/_authenticated/ai-insights/": {
      "filePath": "_authenticated/ai-insights/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/products/": {
      "filePath": "_authenticated/products/explore/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/tax-information/": {
      "filePath": "_authenticated/tax-information/add-country-of-residence/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/auth/login/": {
      "filePath": "auth/login/route.tsx",
      "parent": "/auth/login"
    },
    "/auth/reset-password/": {
      "filePath": "auth/reset-password/route.tsx",
      "parent": "/auth/reset-password"
    },
    "/auth/reset-two-factor/": {
      "filePath": "auth/reset-two-factor/route.tsx",
      "parent": "/auth/reset-two-factor"
    },
    "/_authenticated/products/$productCode": {
      "filePath": "_authenticated/products/details/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/login-method": {
      "filePath": "_authenticated/settings/login-method/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/two-factor": {
      "filePath": "_authenticated/settings/two-factor/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/update-password": {
      "filePath": "_authenticated/settings/update-password/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/tax-information/add-country-of-tax-residence": {
      "filePath": "_authenticated/tax-information/add-country-of-tax-residence/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/_authenticated/tax-information/add-home-address": {
      "filePath": "_authenticated/tax-information/add-home-address/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/_authenticated/tax-information/add-tax-identification-number": {
      "filePath": "_authenticated/tax-information/add-tax-identification-number/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/_authenticated/tax-information/edit-tax-information": {
      "filePath": "_authenticated/tax-information/edit-tax-information/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/_authenticated/tax-information/review-tax-information": {
      "filePath": "_authenticated/tax-information/review-tax-information/route.tsx",
      "parent": "/_authenticated/tax-information"
    },
    "/_authenticated/trade/buy-now": {
      "filePath": "_authenticated/trade/buy-now/route.tsx",
      "parent": "/_authenticated/trade"
    },
    "/_authenticated/trade/recurring-buy": {
      "filePath": "_authenticated/trade/recurring-buy/route.tsx",
      "parent": "/_authenticated/trade"
    },
    "/_authenticated/trade/sell-now": {
      "filePath": "_authenticated/trade/sell-now/route.tsx",
      "parent": "/_authenticated/trade"
    },
    "/_authenticated/verification/error": {
      "filePath": "_authenticated/verification/error/route.tsx",
      "parent": "/_authenticated/verification"
    },
    "/_authenticated/verification/kyc": {
      "filePath": "_authenticated/verification/kyc/route.tsx",
      "parent": "/_authenticated/verification"
    },
    "/_authenticated/verification/submitted": {
      "filePath": "_authenticated/verification/submitted/route.tsx",
      "parent": "/_authenticated/verification"
    },
    "/auth/login/2fa": {
      "filePath": "auth/login/2fa/route.tsx",
      "parent": "/auth/login"
    },
    "/auth/reset-password/completed": {
      "filePath": "auth/reset-password/completed/route.tsx",
      "parent": "/auth/reset-password"
    },
    "/auth/reset-password/request": {
      "filePath": "auth/reset-password/request/route.tsx",
      "parent": "/auth/reset-password"
    },
    "/auth/reset-password/sent": {
      "filePath": "auth/reset-password/sent/route.tsx",
      "parent": "/auth/reset-password"
    },
    "/auth/signup/check-email": {
      "filePath": "auth/signup/check-email/route.tsx",
      "parent": "/auth/signup"
    },
    "/auth/signup/_layout": {
      "filePath": "auth/signup/_authenticated/layout.tsx",
      "parent": "/auth/signup",
      "children": [
        "/auth/signup/_layout/account-details",
        "/auth/signup/_layout/tos",
        "/auth/signup/_layout/verify-email",
        "/auth/signup/_layout/welcome"
      ]
    },
    "/_authenticated/verification/": {
      "filePath": "_authenticated/verification/index.tsx",
      "parent": "/_authenticated/verification"
    },
    "/auth/signup/": {
      "filePath": "auth/signup/index.tsx",
      "parent": "/auth/signup"
    },
    "/_authenticated/funds/deposit/": {
      "filePath": "_authenticated/funds/deposit/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/": {
      "filePath": "_authenticated/funds/withdraw/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/otp/enable": {
      "filePath": "_authenticated/settings/otp/enable/route.tsx",
      "parent": "/_authenticated"
    },
    "/auth/reset-two-factor/_": {
      "filePath": "auth/reset-two-factor/submitted",
      "parent": "/auth/reset-two-factor",
      "children": [
        "/auth/reset-two-factor/_/submitted"
      ]
    },
    "/auth/reset-two-factor/_/submitted": {
      "filePath": "auth/reset-two-factor/submitted/route.tsx",
      "parent": "/auth/reset-two-factor/_"
    },
    "/auth/signup/_layout/account-details": {
      "filePath": "auth/signup/_authenticated/account-details/route.tsx",
      "parent": "/auth/signup/_layout"
    },
    "/auth/signup/_layout/tos": {
      "filePath": "auth/signup/_authenticated/tos/route.tsx",
      "parent": "/auth/signup/_layout"
    },
    "/auth/signup/_layout/verify-email": {
      "filePath": "auth/signup/_authenticated/verify-email/route.tsx",
      "parent": "/auth/signup/_layout"
    },
    "/auth/signup/_layout/welcome": {
      "filePath": "auth/signup/_authenticated/welcome/route.tsx",
      "parent": "/auth/signup/_layout"
    },
    "/_authenticated/funds/deposit/crypto/": {
      "filePath": "_authenticated/funds/deposit/crypto/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/fiat/": {
      "filePath": "_authenticated/funds/deposit/fiat/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/crypto/$productCode/": {
      "filePath": "_authenticated/funds/deposit/crypto/$productCode/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/fiat/bank/": {
      "filePath": "_authenticated/funds/deposit/fiat/bank/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/crypto/$productCode/address": {
      "filePath": "_authenticated/funds/deposit/crypto/$productCode/address/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/crypto/$productCode/complete": {
      "filePath": "_authenticated/funds/deposit/crypto/$productCode/complete/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/deposit/fiat/bank/pop": {
      "filePath": "_authenticated/funds/deposit/fiat/bank/pop/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/2fa": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/2fa/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/complete": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/complete/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/otp": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/otp/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/2fa": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/2fa/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/complete": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/complete/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/otp": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/otp/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/disclaimer/accept/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/disclaimer/acknowledge/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/wallet/verify": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/wallet/verify/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/fiat/$productCode/bank-details/review": {
      "filePath": "_authenticated/funds/withdraw/fiat/$productCode/bank-details/review/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/confirm/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/details/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/otp/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule": {
      "filePath": "_authenticated/funds/withdraw/crypto/$productCode/wallet/edit/travel-rule/route.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
